export default __webpack_public_path__ + "static/1837-f1abd1dc972e9c4492909ba6ab7b82eb.gif";